import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useActingAgency } from '../../stores/actingAgency.store';
import { useAuthStore } from '../../stores/auth.store';
import { useAgenciesStore } from '../../stores/agencies.store';
import { LogOut, ShieldCheck, Icon } from '../ui/Icon';

/** ADR-0041: never forget you are inside someone else's agency. */
export default function ActingAgencyBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const agency = useActingAgency(s => s.agency);
  const userId = useAuthStore(s => s.user?.id);
  const isAdmin = useAuthStore(s => s.user?.isAdmin);
  const setMode = useAgenciesStore(s => s.setMode);
  if (!agency || !isAdmin || !userId) return null;

  function leave() {
    if (!userId) return;
    setMode(userId, 'admin');
    navigate('/admin/agencies');
  }

  return (
    <div role="status" className="shrink-0 flex items-center justify-center gap-3 px-4 py-2 bg-amber-100 dark:bg-amber-900/40 text-amber-900 dark:text-amber-100 text-sm">
      <Icon as={ShieldCheck} size={15} className="shrink-0" />
      <span className="truncate">{t('admin.acting.inside', { agency: agency.name })}</span>
      <button type="button" onClick={leave}
        className="inline-flex items-center gap-1.5 h-7 px-2.5 rounded-lg bg-amber-900 dark:bg-amber-100 text-amber-50 dark:text-amber-950 text-xs font-semibold shrink-0 cursor-pointer hover:opacity-90">
        <Icon as={LogOut} size={13} />
        {t('admin.acting.leave')}
      </button>
    </div>
  );
}
